import React from 'react';
import PropTypes from 'prop-types';

import BookingSummary from '../../BookingSummary';
import DsRoomFooter from './STab-RoomFooter';
import ShareWithOthers from '../../../../share/ShareWithOthers';
import ShareDownload from '../../../../share/ShareDownload';
import HotelShareCart from '../../../../booking/hotels/HotelShareCart';

const getBookingSummary = (booking, lang, chain) => {
  const bookData = booking && booking.rooms && booking.rooms[0];
  if (!bookData) {
    return null;
  }
  const { distribution } = bookData;
  const hotel = booking.hotel.name;
  const dates = {
    checkIn: bookData.check_in,
    checkOut: bookData.check_out,
  };
  return (
    <BookingSummary
      hotel={hotel}
      dates={dates}
      distribution={distribution}
      lang={lang}
      chaing={chain}
      className="justify-between mb-2"
    />
  );
};

const TabCard = (
  {
    children,
    className,
    booking,
    lang,
    chain,
    onShare,
    buildUrl,
  }) => {
  const {
    locator, currency, amount, hotel, loyalty,
  } = booking;
  const taxText = booking.special_tax_text;
  const distribution = booking && booking.rooms && booking.rooms[0] && booking.rooms[0].distribution;
  return (
    <div className={`${className || ''}`}>
        {getBookingSummary(booking, lang, chain)}
          {children}
        <DsRoomFooter currency={currency} amount={amount} taxInfo={taxText} loyalty={loyalty}>
          <ShareDownload
            locator={locator}
            lang={lang}
            is_agent_voucher={false}
            className="text-xs mb-2 md:mb-0"
          />
          <ShareWithOthers
            buildUrl={buildUrl}
            onShare={onShare}
            className="text-xs mb-2 md:mb-0"
            lang={lang}
          >
          <HotelShareCart hotel={hotel} chain={chain}
            lastRequestedInfo={booking.rooms[0]}
            distribution={distribution}
            lang={lang} />
          </ShareWithOthers>
        </DsRoomFooter>
    </div>
  );
};

TabCard.propTypes = {
  buildUrl: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
};

TabCard.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default TabCard;
